import { ModuleWithProviders, NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { RouterModule } from '@angular/router'

import { SharedModule } from '../shared/shared.module'
import { FacetsModule } from '../facets/facets.module'
import { CatalogRoutingModule } from './catalog-routing.module'

import { ProductService } from './services/product-service'
import { FacetService } from './services/facet-service'
import { SKUService } from './services/sku-service'
import { StockService } from './services/stock-service'

import { CatalogContainer } from './containers/catalog-container'
import { DetailsContainer } from './containers/details-container/details-container'
import { ProductPageContainer } from './containers/product-page-container/product-page-container'

import { CatalogPageComponent } from './components/catalog-page/catalog-page.component'
import { FilterListComponent } from './components/filter-list'
import { FilterComponent } from './components/filter'
import { LandingComponent } from './components/landing'
import { CollapsableListComponent } from './components/collapsable-list'
import { CollapsableComponent } from './components/collapsable'

import { ProductEffects } from './effects/product'
import { FacetEffects } from './effects/facet'
import { CatalogEffects } from './effects/catalog'
import { StockEffects } from './effects/stock.effects'

import { reducers } from './reducers'
import { PageRoutingService } from '../core/services/page-routing.service'
import { DetailsPageComponent } from './components/details-page/details-page.component'
import { SKUEffects } from './effects/sku.effects'
import { SkuTableComponent } from './components/sku-table/sku-table.component'
import { SkuTableLineComponent } from './components/sku-table-line/sku-table-line.component';
import { OrderhistoryBannerComponent } from './components/orderhistory-banner/orderhistory-banner.component';
import { ProductPageComponent } from './components/product-page/product-page.component'
import { ProductSizeRowComponent } from './components/product-size-row/product-size-row.component'

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    FacetsModule
  ],
  declarations: [
    CatalogContainer,
    DetailsContainer,
    ProductPageContainer,
    CatalogPageComponent,
    FilterListComponent,
    FilterComponent,
    LandingComponent,
    CollapsableListComponent,
    CollapsableComponent,
    DetailsPageComponent,
    ProductPageComponent,
    ProductSizeRowComponent,
    SkuTableComponent,
    SkuTableLineComponent,
    OrderhistoryBannerComponent
  ],
  entryComponents: [
    DetailsContainer
  ]
})
export class CatalogModule 
{ 
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootCatalogModule,
      providers: [
        ProductService,
        FacetService,
        SKUService,
        PageRoutingService,
        StockService
      ]
    }
  }
}

@NgModule({
  imports: [
    CatalogModule,
    StoreModule.forFeature('catalog', reducers),
    EffectsModule.forFeature([
      CatalogEffects,
      ProductEffects,
      FacetEffects,
      SKUEffects,
      StockEffects
    ]),
    CatalogRoutingModule
  ]
})
export class RootCatalogModule
{ }
